import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DeviceOPEEnum} from "./DeviceOPEEnum";
import {DeviceDraftDTO} from "../gateway-pending-config/GatewayPendingConfigPayloadDTO";

class O {
  deviceId!: number;
  gatewayId!: number;
  updateTs?: string;
  device!: DeviceDraftDTO;
}

class I {
  deviceId!: number;

  // If present, the device is reassigned to this DeviceType before the reset.
  deviceTypeId?: number;
}

export class ResetDeviceFromModelCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(DeviceOPEEnum.ResetDeviceFromModel);
    this.i = new I();
    this.o = new O();
  }
}
